import React from 'react'
import { utcToLocaleString } from '../../../util/DateUtil'

const UserGedcomCreatedColumn = ({ file }) => (
  <>
    {utcToLocaleString(file.created, true)} <br />
    {utcToLocaleString(file.modified, true)}
  </>
)

export default UserGedcomCreatedColumn
